<template>
    <div>
            <div class="row my-3">

              <div class="col col-md-12">
                <div class="form-group required">
                  <label class='control-label'>Номер ИМАР</label>
                  <div><input class="form-control" id="time" v-model="numImar" /></div>
                  <div class="invalid-msg" v-if="v$.numImar.$error">Поле обязательно для заполнения</div>
                </div>
                <div class="form-group required">
                  <label class='control-label'>Дата ИМАР</label>
                  <div><date-component v-model="dateImar"></date-component></div>
                  <div class="invalid-msg" v-if="v$.dateImar.$error">Поле обязательно для заполнения</div>
                </div>                
              </div>

            </div>

            <div>
              <div  class="d-flex align-items-center float-right">
                  <button-component @click="save" class="btn-xs">Утвердить</button-component>
                  <button-component kind="secondary" class="btn-xs mx-2" @click="close">Закрыть</button-component>                
              </div>
            </div>

    </div>
</template>

<script>

import API from '../api/route'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import DateComponent from "@/common/components/DateComponent";
import ButtonComponent from "@/common/ui/ButtonComponent";
import Constants from '../../../common/constants'

export default {
  name: "FinishRouteData",
  props: {
    journalId:Number,
    num: String,
    date: String
  },
  components: {ButtonComponent, DateComponent},
  created() {
  },
  mounted() {
    this.loadNextNumImar();
  },
  emits: ['filldata', 'close'],
  data() {
    return {
        numImar: this.num,
        dateImar: this.date
    };
  },
  watch: {
      journalId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadNextNumImar();
      }
    }
  },
  methods: {
    save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error' );
          return;
        }      
        this.$emit('filldata', {numImar: this.numImar, dateImar: this.dateImar});
    },    
    close() {
      this.$emit('close');
    },
    loadNextNumImar() {
      if(this.journalId && !this.num) {
        API.getNextNumImar(this.journalId).then((response) => {
            this.numImar = response.data;
        });
      }
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
        numImar: { required },
        dateImar: { required },
    }
  }
}; 
</script>
<style lang="scss" scoped>
@import '/src/assets/theme/default/colors.scss';

.form-group.required .control-label:after { 
   content:"*";
   color:red;
}
.form-check.required .control-label:after { 
   content:"*";
   color:red;
}
.invalid-msg {
  color:red;
  font-size: 0.75rem;
}
</style>